import { print } from 'graphql';
import { gql } from 'graphql-tag';

import { AdditionalFields } from '../../models/models';
import { getDateModified, getRoleForMutation } from '../../utilities/utilityFunctions';
import { defaultDoc, getValueFromLocalStorage } from '../share/defaultDoc';
import type {
  DeficiencyVersionFiles,
  DeficiencyVersionFilesDocument,
} from './deficiencyVersionFiles.types';

export const deficiencyVersionFilesPullQueryBuilder = (document: DeficiencyVersionFiles) => {
  let doc = document;
  if (!doc) {
    (doc as unknown) = { ...defaultDoc };
  }

  const query = print(gql`
    query deficiencyVersionFilesFeed(
      $siteId: Int!
      $disciplineId: Int!
      $lastModified: DateTime!
      $isLeadInspector: Boolean!
    ) {
      deficiencyVersionFilesFeed(
        siteId: $siteId
        disciplineId: $disciplineId
        lastModified: $lastModified
        isLeadInspector: $isLeadInspector
      ) {
        fileId
        fileName
        fileAimsUUID
        deficiencyUUID
        originalFileName
        path
        legacyId
        isImageFile
        inspectionId
        deficiencyId
        showOnReport
        fileDescription
        drawingType
        fileCategory
        pcsId
        fkAimsfileTblSp
        sizeMb
        allowSpaccess
        siteId
        disciplineId
        userCreated
        userModified
        isReInspectedFile
        assetId
        extension
        dateCreated
        dateModified
        isDelete
        fileSortOrder
        assetInspectionTask
        fkInspectorField
        fkInspectorLead
        componentVersionInspectionId
        componentVersionId
        fileComponentVersionUUId
      }
    }
  `);
  return {
    query,
    variables: {
      siteId: JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId,
      disciplineId: JSON.parse(getValueFromLocalStorage('selectedDiscipline'))
        ?.selectedDisciplineId,
      lastModified: getDateModified(
        doc?.dateModified,
        doc?.dateCreated,
        doc.siteId,
        doc.disciplineId,
        JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId,
        JSON.parse(getValueFromLocalStorage('selectedDiscipline'))?.selectedDisciplineId,
      ),
      isLeadInspector: getValueFromLocalStorage('isLeadInspector') === 'True',
    },
  };
};

export const deficiencyVersionFilesPushQueryBuilder = (doc: DeficiencyVersionFiles[]) => {
  const document = doc[0];
  const query = print(gql`
    mutation cEDDeficiencyFileInfo(
      $role: Int!
      $MobileDeficiencyFilesFeedInput: MobileDeficiencyFilesFeedInput
    ) {
      cEDDeficiencyFileInfo(role: $role, deficiencyFileRequest: $MobileDeficiencyFilesFeedInput) {
        status
        deficiencyId
        deficiencyUUID
        fileId
        fileUUID
      }
    }
  `);

  const role = getRoleForMutation(document);

  const MobileDeficiencyFilesFeedInput = {
    ...document,
    fkInspectorField: document.fkInspectorField || 0,
    fkInspectorLead: document.fkInspectorLead || 0,
    isReInspectedFile: document.isReInspectedFile || false,
  };

  const variables = {
    MobileDeficiencyFilesFeedInput,
    role,
  };

  return {
    query,
    variables,
  };
};

export const deficiencyVersionFilesPushModifier = (doc: DeficiencyVersionFilesDocument) => {
  const obj: AdditionalFields = {
    ...doc,
  };

  const blackListedProp = ['_meta', 'isDeleted'];
  blackListedProp.forEach(property => {
    obj[property as keyof AdditionalFields] = undefined;
  });

  return obj;
};
